var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('DatosAlumno',{attrs:{"changeStep":_vm.changeStep,"alumno":_vm.alumno,"salir":_vm.salir,"auth":_vm.auth,"changeAuth":_vm.changeAuth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }